import { ActionGoalCategory } from '@src/types'

export const WEEKDAY_ABBREVIATIONS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export const ActionGoalCategories: { [key in ActionGoalCategory | 'all']: string } = {
  all: 'all',
  // ordering matters here for branding purposes
  glucose: 'glucose',
  nutrition: 'nutrition',
  fitness: 'fitness',
  habits: 'habits',
}

export const CATEGORY_ORDER: ActionGoalCategory[] = [
  ActionGoalCategory.Glucose,
  ActionGoalCategory.Nutrition,
  ActionGoalCategory.Fitness,
  ActionGoalCategory.Habits,
]

export const SUMMARY_CARD_HEIGHT = 125
export const GOAL_CARD_HEIGHT = 92
export const ACTIVE_GOALS_MARGIN_TOP = 28

export const MIN_ACTION_GOAL_CARDS = 1
